import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PupilFormValues } from '../../components/customer-details-form/CustomerDetailsForm';

export enum YesNoOptions {
    Yes = 1,
    No = 2,
}

// State

export interface UserSelectionState {
    productId?: number;
    location?: endpoints.Location;
    lessonTime?: Date;
    pupilDetails: PupilFormValues;
}

export const initialFormValues: PupilFormValues = {
    purchaser: undefined,
    thirdParty: {
        firstName: '',
        surname: '',
        email: '',
        confirmEmail: '',
        addressLine1: '',
        addressLine2: '',
        town: '',
        countyId: undefined,
        eircode: '',
        mobile: '',
    },
    sameDetails: undefined,
    pupil: {
        firstName: '',
        surname: '',
        dob: {
            dobDay: '',
            dobMonth: '',
            dobYear: '',
        },
        addressLine1: '',
        addressLine2: '',
        town: '',
        countyId: undefined,
        eircode: '',
        mobile: '',
        emergencyNumber: '',
        email: '',
        confirmEmail: '',
        marketingConsent: false,
        termConditionsConsent: false,
    }
};

export const initialState: UserSelectionState = {
    productId: undefined,
    location: undefined,
    lessonTime: undefined,
    pupilDetails: initialFormValues,
};

// Slice

export const userSelectionSlice = createSlice({
    name: 'userSelection',
    initialState,
    reducers: {
        setSelectedProduct: (state, action: PayloadAction<{ productId: number }>) => {
            if (action.payload.productId !== undefined) {
                state.productId = action.payload.productId;
            }
        },
        setSelectedLocation: (state, action: PayloadAction<{ location: endpoints.Location }>) => {
            if (action.payload.location !== undefined) {
                state.location = action.payload.location;
            }
        },
        setSelectedLessonTime: (state, action: PayloadAction<{ lessonTime: Date }>) => {
            if (action.payload.lessonTime !== undefined) {
                state.lessonTime = action.payload.lessonTime;
            }
        },
        setPupilDetails: (state, action: PayloadAction<{ pupilDetails: PupilFormValues }>) => {
            if (action.payload.pupilDetails !== undefined) {
                state.pupilDetails = action.payload.pupilDetails;
            }
        },
    },
});

// Actions
export const {
    setSelectedProduct,
    setSelectedLocation,
    setSelectedLessonTime,
    setPupilDetails,
} = userSelectionSlice.actions;

// Reducer
export const userSelectionReducer = userSelectionSlice.reducer;